/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { ISession } from '../../../models/pro-sites';
import {
    IEarmoldSelection,
    IOption,
    IOrderDetails,
    IPairAidPart,
    IProductDetail,
} from '../../../models/product-detail';
import { CartItemTypes, yesNo } from '../../common/constants';
import RowElementWrapper from '../../common/row-element-wrapper';
import EarmoldStyleSelection from './earmold-style-selection';
import ProductOptions from './product-options';
import { ProductOrderFormErrors } from './validation';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
interface Props {
    earmolds: IEarmoldSelection[];
    productDetails: IProductDetail;
    orderDetails: IOrderDetails;
    onChange: (name: string, value?: number | boolean) => void;
    updateSelectedOptions: (
        rightSelectedIds: number[],
        leftSelectedIds: number[],
        isEarmold: boolean
    ) => void;
    session: ISession | null;
    updateOptionsOnProductDetailState: (
        options: IOption[] | null,
        isEarmold: boolean
    ) => void;
    updateCrosPairAid: (pairAid?: IPairAidPart) => void;
    errors: ProductOrderFormErrors;
}

const EarmoldOptions: React.FC<Props> = ({
    earmolds,
    productDetails,
    orderDetails,
    onChange,
    session,
    updateSelectedOptions,
    updateOptionsOnProductDetailState,
    updateCrosPairAid, // TODO: Move to update.
    errors,
}: Props) => {
    const intl = useIntl();
    return (
        <>
            {![CartItemTypes.Earmold, CartItemTypes.SoundGearEarmold].includes(
                productDetails!.cartItemTypeId!
            ) && (
                <>
                    {[
                        CartItemTypes.BteWithEarmold,
                        CartItemTypes.RicWithEarmold,
                    ].includes(orderDetails.cartItemTypeId!) &&
                        orderDetails.cros &&
                        ((orderDetails.side === 'R' &&
                            orderDetails.rightSelectedIds.includes(510)) ||
                            (orderDetails.side === 'L' &&
                                orderDetails.leftSelectedIds.includes(
                                    510
                                ))) && (
                            <RowElementWrapper>
                                <div className="col-sm-6">
                                    <h3 id="Earmold_for_CROS">
                                        <FormattedMessage
                                            id="Earmold_for_CROS"
                                            defaultMessage="Earmold for CROS Transmitter?"
                                        />
                                    </h3>
                                </div>
                                <div className="col-sm-6">
                                    {yesNo.map((x) => {
                                        return (
                                            <div key={x.text}>
                                                <input
                                                    type="radio"
                                                    checked={
                                                        (orderDetails.showEarmoldForMonauralCros &&
                                                            x.value) ||
                                                        (!orderDetails.showEarmoldForMonauralCros &&
                                                            !x.value)
                                                    }
                                                    name={'earmoldForCros'}
                                                    id={x.english}
                                                    onChange={(e) => {
                                                        onChange(
                                                            e.target.name,
                                                            x.value
                                                        );
                                                    }}
                                                />
                                                <label>
                                                    {intl.formatMessage({
                                                        id: x.text,
                                                        defaultMessage: x.text,
                                                    })}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </RowElementWrapper>
                        )}
                    {(orderDetails.side === 'B' ||
                        orderDetails.showEarmoldForMonauralCros ||
                        orderDetails.rightSelectedIds.includes(511) ||
                        orderDetails.leftSelectedIds.includes(511) ||
                        !orderDetails.cros) && (
                        <RowElementWrapper>
                            <div className="col-sm-12">
                                <h3 id="Select_Earmold_Type">
                                    <FormattedMessage
                                        id="Select_Earmold_Type"
                                        defaultMessage="Select Earmold Type"
                                    />
                                </h3>
                            </div>
                            <div className="col-sm-12">
                                <div className="col-sm-3">
                                    <img
                                        src={`/services/catalogs/${
                                            session!.catalog
                                        }/designs/${
                                            orderDetails.earmoldDesignId
                                                ? orderDetails.earmoldDesignId
                                                : orderDetails!
                                                      .cartItemTypeId ===
                                                  CartItemTypes.RicWithEarmold
                                                ? 151
                                                : 139
                                        }/image`}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                        }}
                                    />
                                </div>
                                <div className="col-sm-9">
                                    <EarmoldStyleSelection
                                        earmoldsTypes={earmolds}
                                        orderState={orderDetails}
                                        onChange={onChange}
                                        errors={errors}
                                    />
                                </div>
                            </div>
                        </RowElementWrapper>
                    )}
                </>
            )}
            {productDetails!.earmoldOptions && (
                <ProductOptions
                    options={productDetails!.earmoldOptions}
                    productDetails={productDetails!}
                    orderDetails={orderDetails}
                    isEarmold={true}
                    updateSelectedOptions={updateSelectedOptions}
                    updateCrosPairAid={updateCrosPairAid}
                    errors={errors}
                />
            )}
        </>
    );
};

export default EarmoldOptions;
